class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const line = this.dataset.index;

      // get cart
      const cart = await fetch('/cart.js').then(res => res.json());
      const item = cart.items[line - 1];

      // check if deleting free gift
      if (item?.properties?._gift === 'true') {
        sessionStorage.setItem("giftRemoved", true);
        window.giftRemovedManually = true;
      }

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(line, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.setupBundleButton = this.setupBundleButton.bind(this);
    this.handleBundleDelete = this.handleBundleDelete.bind(this);
    this.updateCartBubbleCount = this.updateCartBubbleCount.bind(this);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      return this.onCartUpdate();
    });
    this.setupBundleButton();
  }

  setupBundleButton() {
    document.addEventListener('click', (event) => {
      if (event.target.closest('#delete-cart-bundle')) {
        this.handleBundleDelete();
      }
    })
  }

  async handleBundleDelete() {
    try {
      const cart = await fetch('/cart.js').then(res => res.json());

      if (!cart.items.length) {
        window.location.reload();
        return;
      }

      const updates = {};
      let bundleFound = false;

      // Loop through all cart items
      cart.items.forEach(item => {
        const hasBundleProperty = item.properties && item.properties['bundle-product'];

        // Remove only bundle products
        if (hasBundleProperty) {
          updates[item.key] = 0; // delete this bundle product
          bundleFound = true;
        }
      });

      if (!bundleFound) {
        this.showNoBundleItemsMessage?.();
        return;
      }

      // Call update API only for bundle products (don’t touch others)
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      const updatedCart = await response.json();

      // ✅ Update bubble and refresh UI
      this.updateCartBubbleCount?.(updatedCart.item_count);
      this.onCartUpdate?.();

      if (updatedCart.item_count === 0) {
        const cartItems = document.querySelector('cart-items');
        if (cartItems) cartItems.classList.add('is-empty');
        if (!window.location.href.includes('/cart')) {
          window.refreshCartDrawer();
        }
      }

    } catch (error) {
      console.error('Error removing bundle products:', error);
      this.showErrorMessage?.();
    }
  }



  // ✅ New helper method for cart bubble update
  updateCartBubbleCount(count) {
    const cartBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    const visuallyHidden = document.querySelector('.cart-count-bubble .visually-hidden');
    const bubbleWrapper = document.querySelector('.cart-count-bubble');

    if (cartBubble) cartBubble.textContent = count;
    if (visuallyHidden) visuallyHidden.textContent = `${count} varer`; // or `${count} items`

    if (bubbleWrapper) {
      bubbleWrapper.style.display = 'flex';
    }
  }

  showNoBundleItemsMessage() {
    alert('No bundle items found in your cart.');
  }

  showErrorMessage() {
    alert('An error occurred while trying to remove bundle items.');
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (!input) return;
    input.value = input?.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) targetElement.replaceWith(sourceElement);
          }
          // updateCartForShippingProgress();
          if (typeof window.handleGiftProduct === 'function') {
            fetch('/cart.js')
              .then((res) => res.json())
              .then((cartState) => {
                window.handleGiftProduct(cartState);
              })
              .catch((err) => {
                console.error('Error fetching cart for gift product logic during cart update:', err);
              });
          }
        })
        .catch(console.error);
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch(console.error);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });

          // ✅ Update cart bubble here too for normal quantity change
          this.updateCartBubbleCount(parsedState.item_count);

          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            message = typeof updatedValue === 'undefined'
              ? window.cartStrings.error
              : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
          this.updateLiveRegions(line, message);
        });

        setTimeout(() => {
          window.handleGiftProduct(parsedState);
        }, 100);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        if (window.location.href.includes("cart")) window.initializeCarousel();
        this.disableLoading(line);
        if (typeof window.handleGiftProduct === 'function') {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cartState => {
              window.handleGiftProduct(cartState);
            })
            .catch(err => {
              console.error('Error fetching cart for gift product logic:', err);
            });
        } else {
          console.warn('handleGiftProduct function is not available on window.');
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    setTimeout(() => cartStatus.setAttribute('aria-hidden', true), 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

// Sticky checkout button for mobile Device
window.addEventListener('scroll', function () {
  var scrollableDiv = document.querySelector('.cart-items');
  var targetDiv = document.getElementById('cartCheckoutButton');
  if (scrollableDiv && targetDiv) {
    var scrollPosition = window.scrollY;
    var scrollableHeight = scrollableDiv.offsetHeight;
    if (scrollPosition < scrollableHeight || scrollPosition > (scrollableHeight + 500)) {
      targetDiv.classList.add('sticky-checkout');
    } else {
      targetDiv.classList.remove('sticky-checkout');
    }
  }
});

// --- Begin Gift code ---//
window.refreshCart = function () {
  const cartItems = document.querySelector('cart-items');
  if (!cartItems) return;
  const sections = cartItems.getSectionsToRender();
  const sectionIds = sections.map((section) => section.section).join(',');
  const sectionsUrl = `${routes.cart_url}?sections=${sectionIds}`;

  let cartEmpty = false
  fetch(sectionsUrl)
    .then((res) => res.json())
    .then((parsedSections) => {
      sections.forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id)?.querySelector(section.selector) ||
          document.getElementById(section.id);

        if (elementToReplace && parsedSections[section.section]) {
          const html = new DOMParser().parseFromString(parsedSections[section.section], 'text/html');
          const cart_items = html.querySelector('.main-cart__wrapper')?.getAttribute('data-cart-count');
          if (cart_items == '0' || cart_items == 0) {
            cartEmpty = true
          }
          const inner = html.querySelector(section.selector);
          if (inner) elementToReplace.innerHTML = inner.innerHTML;
        }
      });
      // If cart is empty adding is-empty class to cart section
      if (cartEmpty) {
        emptyCart();
      }
    })
    .catch((e) => console.error('Cart refresh failed', e));
};


window.refreshCartDrawer = function () {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const sections = cartDrawer.getSectionsToRender();
  const sectionIds = sections.map((section) => section.id).join(',');

  let cartDrawerEmpty = false
  fetch(`${routes.cart_url}?sections=${sectionIds}`)
    .then((res) => res.json())
    .then((parsedState) => {
      sections.forEach((section) => {
        const sectionHTML = parsedState[section.id];
        const htmlDoc = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const cartDrawerItems = htmlDoc.querySelector('cart-drawer')?.getAttribute('data-cart-count');
        if (cartDrawerItems && cartDrawerItems == '0' || cartDrawerItems == 0) {
          cartDrawerEmpty = true
        }
      });

      // If cart drawer empty adding is-empty class to cart drawer 
      if (cartDrawerEmpty) {
        emptyCart();
      }

      cartDrawer.renderContents({
        id: null, // or use product ID if available
        sections: parsedState
      });
    })
    .catch((e) => console.error('Cart drawer refresh failed', e));
};

function emptyCart() {
  const cartDrawerWrapper = document.querySelector('cart-drawer');
  const cartFooter = document.querySelector('.main-cart__wrapper');
  if (cartFooter) cartFooter.classList.add('is-empty');
  if (cartDrawerWrapper) cartDrawerWrapper.classList.add('is-empty');
}

// --- Begin Gift logic ---//
const freeGiftWrapper = document.querySelector('.free-gift-wrapper');

const GIFT_VARIANT_ID = freeGiftWrapper
  ? parseInt(freeGiftWrapper.getAttribute('data-free-gift-id'))
  : null;

const GIFT_THRESHOLD = freeGiftWrapper
  ? parseFloat(freeGiftWrapper.getAttribute('data-free-gift-threshold')) * Shopify.currency.rate
  : null;

const GIFT_THRESHOLD_QUANTITY = freeGiftWrapper
  ? parseInt(freeGiftWrapper.getAttribute('data-quantity-threshold'))
  : null;

window.isGiftProductUpdating = false;

window.handleGiftProduct = async function (cartState) {
  if (window.isGiftProductUpdating) return;

  // If user removed gift manually → don't add again
  let freeGiftRemoved = sessionStorage.getItem("giftRemoved");
  if (window.giftRemovedManually || freeGiftRemoved == 'true') return;
  
  window.isGiftProductUpdating = true;

  try {
    if (!cartState || !cartState.items) return releaseGiftLock();

    let totalPrice = 0;
    let giftLineIndexes = [];
    let giftCount = 0;

    cartState.items.forEach((item, idx) => {
      if (
        parseInt(item.variant_id) === GIFT_VARIANT_ID &&
        item.properties && item.properties._gift === 'true'
      ) {
        giftLineIndexes.push(idx + 1);
        giftCount += item.quantity;
      } else if (parseInt(item.variant_id) !== GIFT_VARIANT_ID || !item.properties || item.properties._gift !== 'true') {
        // if (item.product_type != "Device") {
          totalPrice += (item.final_line_price || (item.price * item.quantity)) / 100;
        // }
      }
    });

    // Free Gift Based on the Cart total Threshold
    if (GIFT_THRESHOLD > 0) {
      if (totalPrice >= GIFT_THRESHOLD) {
        if (giftCount === 0) {
          await window.addGiftProductAsync(GIFT_VARIANT_ID);
        } else if (giftCount > 1) {
          await window.removeGiftProductsAsync(giftLineIndexes);
          await window.addGiftProductAsync(GIFT_VARIANT_ID);
        }
      } else if (giftLineIndexes.length > 0) {
        await window.removeGiftProductsAsync(giftLineIndexes);
      }
    }

    // Free Gift Based on the Quantity Threshold
    let cartQuantity = cartState.item_count
    if (giftCount > 0) {
      cartQuantity = cartQuantity - giftCount
    }
    if (GIFT_THRESHOLD_QUANTITY > 0) {
      if (cartQuantity >= GIFT_THRESHOLD_QUANTITY) {
        if (giftCount === 0) {
          await window.addGiftProductAsync(GIFT_VARIANT_ID);
        } else if (giftCount > 1) {
          await window.removeGiftProductsAsync(giftLineIndexes);
          await window.addGiftProductAsync(GIFT_VARIANT_ID);
        }
      } else if (giftLineIndexes.length > 0) {
        await window.removeGiftProductsAsync(giftLineIndexes);
      }
    }

  } finally {
    releaseGiftLock();
  }
};

function releaseGiftLock() {
  window.isGiftProductUpdating = false;
}

// Async/await wrappers for add/remove
window.addGiftProductAsync = async function (variantId, properties = {}) {
  const formData = {
    id: variantId,
    quantity: 1,
    properties: { _gift: 'true', ...properties }
  };
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData)
  });

  if (window.location.pathname === '/cart') {
    window.refreshCart();
  } else {
    window.refreshCartDrawer();
  }
  if (typeof window.onCartUpdate === 'function') window.onCartUpdate();
};

window.removeGiftProductsAsync = async function (lineIndexes) {
  for (const line of lineIndexes) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line, quantity: 0 })
    });
  }
  if (window.location.pathname === '/cart') {
    window.refreshCart();
  } else {
    window.refreshCartDrawer();
  }
  if (typeof window.onCartUpdate === 'function') window.onCartUpdate();
};

window.syncAutoProductWithCart = function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      window.handleGiftProduct(cart);
    });
};


document.addEventListener('DOMContentLoaded', function () {
  window.syncAutoProductWithCart();
});

// --- End gift logic  ---//